import { createRouter, createWebHistory } from 'vue-router'
import users_table from '@/views/users_table'
import user_page from '@/views/user_page'
import user_form from '@/views/user_form'


const routes = [
  {
    path: '/',
    name: 'home',
    component: users_table
  },
  {
    path: '/user/:id',
    name: 'user',
    component: user_page
  },
  {
    path: '/form/:id',
    name: 'form',
    component: user_form
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
